export const CallUtil = {
	isNumber(text): boolean
	{
		return /^([\d #()+./-]+)$/.test(text);
	},
};
